import { ref } from 'vue';
import axios from 'axios';
import { EventEmitter } from 'events'       


const API = axios.create({
    baseURL: 'https://kings-logix.ru/api',
    responseType: 'json',
    headers: {
        'X-Custom-Header': 'foobar',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
    },
});

class WebSocketService extends EventEmitter {
    socket = null;
    messages = ref([]);
    connectionStatus = ref<'connecting' | 'open' | 'closed' | 'error'>('closed');

    getToken() {
        return localStorage.getItem('userToken');
    }

    connect(table, userId) {
        const token = this.getToken();
        if (!token) {
            console.error('Токен отсутствует. Невозможно установить WebSocket соединение.');
            return;
        }

        const url = `wss:/kings-logix.ru/socket/tables/${table}/${userId}?token=${encodeURIComponent(token)}`;
        // const url = `ws:/localhost:8080/socket/tables/${table}/${userId}?token=${encodeURIComponent(token)}`;
        console.log(`Попытка подключения к WebSocket: ${url}`);
        // this.connectionStatus.value = 'connecting';

        try {
            this.socket = new WebSocket(url);

            this.socket.onopen = () => {
                console.log('WebSocket соединение установлено');
                // this.connectionStatus.value = 'open';
            };

            this.socket.onmessage = (event) => {
                console.log('Сырой ответ:', event.data);
                try {
                    const message = JSON.parse(event.data);
                    console.log('Получено сообщение:', message);
                    this.emit('messageReceived', message);
                    this.messages.value.push(message);
                } catch (error) {
                    console.error('Ошибка обработки входящего сообщения:', error);
                }
            };

            this.socket.onerror = (error) => {
                console.error('Ошибка WebSocket:', error);
                // this.connectionStatus.value = 'error';
            };

            this.socket.onclose = (event) => {
                console.log('WebSocket соединение закрыто:', event);
                // this.connectionStatus.value = 'closed';
            };
        } catch (error) {
            console.error('Ошибка при создании WebSocket:', error);
            // this.connectionStatus.value = 'error';
        }
    }

    sendMessage(dialogId, message) {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            const payload = JSON.stringify({ dialogId, ...message });
            console.log('Отправка сообщения:', payload);
            this.socket.send(payload);
        } else {
            console.error('WebSocket не подключен или соединение закрыто');
        }
    }

    onStatusUpdate() {
        if (this.socket) {
            this.socket.onmessage = (event) => {
                const message = JSON.parse(event.data);
                if (message.type === 'status_update') {
                    return message;
                }
            };
        }
    }

    disconnect() {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.close();
            console.log('WebSocket отключен');
        } else {
            console.warn('WebSocket уже отключен или не существует');
        }
    }
}

export const webSocketService = new WebSocketService();